// ReadyRow.jsx
import { Button, Chip, Paper, Stack, Typography } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import moment from 'moment'

const ReadyRow = ({ item, onRemove }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.default',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'stretch', md: 'center' }}
        justifyContent="space-between"
        gap={1}
      >
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          <CheckCircleOutlineIcon color="success" fontSize="small" />
          <Typography fontWeight={700}>{item.name}</Typography>
          {item.size && <Typography color="text.secondary">{item.size}</Typography>}
          <Chip
            size="small"
            color="success"
            variant="outlined"
            label={
              item?.noExpiry
                ? 'No expiry'
                : `Expires ${moment(item.expiryDate).format('DD/MM/YYYY')}`
            }
          />
        </Stack>
        <Button
          size="small"
          color="inherit"
          variant="outlined"
          onClick={() => onRemove(item)}
          startIcon={<DeleteOutlineIcon />}
        >
          Remove
        </Button>
      </Stack>
    </Paper>
  )
}

export default ReadyRow
